import { PopPupChung } from "../../../../../component/PopPupChung";
import { useState } from "react";
import Notify from "../../../../../component/Notify/Notify";
import { useNavigate } from "react-router-dom";
import "./PopPupQr.scss";

function PopPupQr({ isOpen, setisOpen, bankData }) {
  const [animateOut, setAnimateOut] = useState(false);
  const [notification, setNotification] = useState("");
  const navigate = useNavigate();

  const handleClose = () => {
    setAnimateOut(true);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setNotification("คัดลอกแล้ว");
  };

  return (
    <PopPupChung
      isOpen={isOpen}
      setisOpen={setisOpen}
      animateOut={animateOut}
      setAnimateOut={setAnimateOut}
    >
      {notification && (
        <Notify
          message={notification}
          setcontent={setNotification}
          type="success"
        />
      )}

      <div className="popupqr">
        {/* HEADER */}
        <div className="popupqr-header">
          <h3>ข้อมูลการฝากเงิน</h3>
        </div>

        {/* BODY */}
        <div className="popupqr-body">
          {/* LEFT */}
          <div className="left-content">
            <div className="info-item">
              <span className="label">ธนาคาร:</span>
              <span className="value">KBank (Kasikornbank)</span>
            </div>

            <div className="info-item">
              <span className="label">เลขที่บัญชี:</span>

              <div className="info-value-copy">
                <span className="value">1771799902</span>

                <img
                  src="/copy.png"
                  className="icon-copy"
                  alt="Copy"
                  onClick={() =>
                    copyToClipboard(bankData?.bank_account)
                  }
                />
              </div>
            </div>

            <div className="info-item">
              <span className="label">ชื่อบัญชี:</span>

              <div className="info-value-copy">
                <span className="value">หจก. ค้ำคูณอาหารสัตว์</span>

                <img
                  src="/copy.png"
                  className="icon-copy"
                  alt="Copy"
                  onClick={() =>
                    copyToClipboard(bankData?.bank_account_name)
                  }
                />
              </div>
            </div>

            <div className="info-item amount-item">
              <span className="label">จำนวนเงิน:</span>

              <span className="amount">
                {Number(bankData?.amount * 1).toLocaleString()} THB
              </span>
            </div>

            {/* <div className="info-item">
              <span className="label">Nội dung:</span>
              <span>{bankData?.code}</span>
              <img
                src="/copy.png"
                className="icon-copy"
                alt="Copy"
                onClick={() => copyToClipboard(bankData?.code)}
              />
            </div> */}
          </div>

          {/* RIGHT */}
          {/* <div className="right-content">
            <p>สแกน QR Code เพื่อชำระเงิน</p>

            <div className="qr-box">
              {bankData?.qrImageUrl ? (
                <img
                  src={bankData.qrImageUrl}
                  alt="QR code"
                  style={{ maxWidth: "200px" }}
                />
              ) : (
                <img
                  src="/qrck.png"
                  alt="QR mặc định"
                  style={{ maxWidth: "200px" }}
                />
              )}
            </div>
          </div> */}
        </div>

        {/* BUTTON */}
        <div className="popupqr-actions">
          <button
            className="btn-default"
            onClick={handleClose}
          >
            ยกเลิก
          </button>

          <button
            className="btn-primary"
            onClick={() => navigate("/lichsunaprutmobile")}
          >
            ยืนยันว่าฝากเงินแล้ว
          </button>
        </div>
      </div>
    </PopPupChung>
  );
}

export default PopPupQr;